/* Time from now needs compare time now from time given */
/* eslint-disable no-else-return */
export default (timeGiven) => {
    if (!timeGiven) {
        return;
    }

    const currentDate = new Date();
    let givenDate = timeGiven.replace(/\s/g, 'T');
    givenDate = new Date(givenDate);
    // Test Year
    if (currentDate.getFullYear() > (givenDate.getFullYear())) {
        // Month & Year
        if (currentDate.getMonth() >= (givenDate.getMonth())) {
            return 'over a year ago';
        } else {
            const month = (givenDate.getMonth() - currentDate.getMonth());
            // Months or month
            if (month > 1) {
                return `${month} months ago`;
            }

            return `${month} month ago`;
        }
        // Test Month
    } else if (currentDate.getMonth() > (givenDate.getMonth())) {
        const month = (currentDate.getMonth() - givenDate.getMonth());
        // Months or month
        if (month > 1) {
            return `${month} months ago`;
        }

        return `${month} month ago`;
        // Test Day
    } else if (currentDate.getDate() > (givenDate.getDate())) {
        const day = (currentDate.getDate() - givenDate.getDate());
        // Days or Day
        if (day > 1) {
            return `${day} days ago`;
        }

        return `${day} day ago`;
        // Test Hour
    } else if (currentDate.getHours() > (givenDate.getHours())) {
        const hours = (currentDate.getHours() - givenDate.getHours());
        // Hours or Hour
        if (hours > 1) {
            return `${hours} hours ago`;
        }

        return `${hours} hour ago`;
        // Test Minutes
    } else if (currentDate.getMinutes() > (givenDate.getMinutes())) {
        const minutes = (currentDate.getMinutes() - givenDate.getMinutes());
        // Minutes or Update Now
        if (minutes > 2) {
            return `${minutes} hours ago`;
        }

        return 'updated now';
    }
};

